import { useDisclosure } from '@/hooks';
import { useBankSlipFormContext } from '@/pages/FinancialPages/BankSlipPage';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button } from 'antd';
import WriteOffGenerateRemmitanceModal from './WriteOffGenerateRemmitanceModal';
import { GenerateRemittanceByWriteOffRequest } from '@/core/domain/financial/Boletos/Boletos.types';
import { useGenerateRemmitanceByWriteOff } from '@/core/domain/financial/Boletos/Boletos.hooks';
import moment from 'moment';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';

export default function WriteOffGenerateRemmitanceButton() {
  const [returnFileOpened, returnFileAction] = useDisclosure();
  const report = useReportGenerate();

  const { queryParams } = useBankSlipFormContext();

  const generateRemmitanceByWriteOff = useGenerateRemmitanceByWriteOff();

  async function handleGenerateRemmitanceByWriteOff(
    params: GenerateRemittanceByWriteOffRequest,
    callback?: ReportCallback,
  ) {
    const result = await generateRemmitanceByWriteOff.mutateAsync({
      ...params,
    });

    if (callback) {
      callback(result);
    }
  }

  return (
    <>
      <Button
        disabled={
          !hasPermissions([Authorities.FINANCIAL_BILL_READ_RETURN_FILE])
        }
        block
        type="primary"
        onClick={returnFileAction.open}
      >
        Leitura arquivo de retorno
      </Button>

      <WriteOffGenerateRemmitanceModal
        open={returnFileOpened}
        onCancel={returnFileAction.close}
        onCallback={(values) =>
          handleGenerateRemmitanceByWriteOff(values, (result) =>
            report.downloadFile({
              result,
              fileName: `remessa_de_baixa_${moment().format('DD-MM-YYYY')}.zip`,
            }),
          )
        }
        companyId={queryParams.companyId}
      />
    </>
  );
}
